'use client'
import { Link } from '@/components/ui/deprecated-link'
import { isHourly } from '@/modules/salary/common/utils'
import { SalaryFilterParam } from '../constants'
import { SalaryPayPeriod } from '@/modules/salary/table/constants'
import { SALARY_FULL_TIME_VALUE } from '@/modules/surveys/configs/onboarding/current-job-pane-config'
import { usePathname, useSearchParams } from 'next/navigation'
import { useSalaryParams } from '../common/use-salary-params'
import { useSalaryFilters } from '../filters/use-salary-filters'

const ALLOW_JOB_TYPE_FOR_HOURLY_PAY_PERIOD = [
  SALARY_FULL_TIME_VALUE,
  //SALARY_PART_TIME_VALUE,
]

export function SalaryPayPeriodToggle({
  isAuthenticated,
}: {
  isAuthenticated: boolean
}) {
  const { jobType } = useSalaryParams()
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const { updateSalaryFilters } = useSalaryFilters({
    isAuthenticated,
  })
  const payPeriod = searchParams.get(
    SalaryFilterParam.payPeriod,
  ) as SalaryPayPeriod | null

  const hasPayPeriodToggle =
    !jobType || ALLOW_JOB_TYPE_FOR_HOURLY_PAY_PERIOD.includes(jobType)

  if (!hasPayPeriodToggle) {
    return null
  }

  const isHourlyPayPeriod = isHourly(jobType, payPeriod)
  const params = new URLSearchParams(searchParams.toString())

  return (
    <Link
      href={`${pathname}?${params.toString()}`}
      className="z-10 text-xs"
      onClick={() => {
        // set the opposite pay period for the link
        updateSalaryFilters({
          [SalaryFilterParam.payPeriod]: isHourlyPayPeriod
            ? SalaryPayPeriod.Annually
            : SalaryPayPeriod.Hourly,
        })
      }}
    >
      {isHourlyPayPeriod ? 'See Annual' : 'See Hourly'}
    </Link>
  )
}
